import { connect } from 'react-redux';

import getSurgeIncentives from '../reducers/selectors/getSurgeIncentives';
import ProviderSurgeIncentiveSearchResults from './provider-surge-incentive-search-results';
import { providerSurgeIncentiveUpdateSearchFilters } from '../actions';

const mapStateToProps = state => {
  const surgeIncentives = getSurgeIncentives(state);

  const perPage =
    surgeIncentives.length > state.providerSurgeIncentive.searchFilters.per_page
      ? surgeIncentives.length
      : state.providerSurgeIncentive.searchFilters.per_page;

  return {
    surgeIncentives,
    page: state.providerSurgeIncentive.searchFilters.page,
    perPage,
    totalEntries: state.providerSurgeIncentive.incentives.totalEntries,
    loading: state.providerSurgeIncentive.searchRequest.isLoading
  };
};

const mapDispatchToProps = dispatch => ({
  changePage: page => dispatch(providerSurgeIncentiveUpdateSearchFilters({ page }))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProviderSurgeIncentiveSearchResults);
